import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Box from "../Box";
import "./styles.scss";

export const Banner = ({ handleCloseBanner }) => {
  return (
    <div className="banner-div">
      <div className="parent-container">
        <div className="title_div">
          <span className="title">
            Elevate your experience with Our Cool New Dashboard! 🎉
          </span>
          <span className="sub-link">
            We’re excited to introduce a sleek, user-friendly dashboard designed
            to streamline your experience like never before.
          </span>
        </div>
        <div className="btn_container">
          <a href="https://cms.dev.easyboard.co.in/" className="banner-link">
            Try it out now
          </a>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-x"
            onClick={handleCloseBanner}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === " " || e.key === "enter") handleCloseBanner;
            }}
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export const Page = ({ children, className, isNotAllowed = false }) => (
  <Box
    className={classNames("page-section", className)}
    tag="section"
    direction="column"
    position="relative"
  >
    {!isNotAllowed ? (
      <div style={{ position: "relative" }}>{children}</div>
    ) : (
      <div className="flex flex-jc-c ai-i-c" style={{ marginTop: "40%" }}>
        {" "}
        You don't have permission to view this page.{" "}
      </div>
    )}
  </Box>
);

Page.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Page;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/layout/Page/index.js